var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"loader",class:_vm.tamanho},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ring"},[_c('i'),_c('i'),_c('i'),_c('i')])}]

export { render, staticRenderFns }